import React from 'react';

const OurMission = () => {
  return ( 
    <div className="our-mission">
      <p className="fs-18 font-weight-extrabold">OUR MISSION</p>
      <p className="text-primary fs-54 font-weight-thin text">Make the world a safer place - <br></br>one ride at a time</p>
      <div className="text-outer text-right">
        <div className="text pr-5">
          <p>SmartDrive is committed to delivering innovative solutions that make the<br></br> roads safer. With change and growth at the forefront, the team provides<br></br> innovative solutions to businesses with an unbending passion. We focus our<br></br> energies on empowering transport fleets for safer journeys with compassion,<br></br> patience, and empathy at the core of our company’s ideals.</p>
        </div>
      </div>
    </div>
   );
}
 
export default OurMission;